export default "__VITE_ASSET__BvVv4xSl__"